import { Extension } from '@tiptap/core'
import { PluginKey } from '@tiptap/pm/state'
import Suggestion from '@tiptap/suggestion'
import { createMemeSuggestion } from './MemeSuggestion'

// Unique key: the action-command Suggestion already occupies the default
// 'suggestion' plugin key, and ProseMirror rejects duplicate keyed plugins.
export const MemeSuggestionPluginKey = new PluginKey('memeSuggestion')

// `[[` meme autocomplete. Registered by TiptapEditor only while the central
// Memes rollout is enabled; the backing endpoint uses the same rollout policy.
export const MemeSuggestionExtension = Extension.create({
    name: 'memeSuggestion',

    addProseMirrorPlugins() {
        return [
            Suggestion({
                editor: this.editor,
                pluginKey: MemeSuggestionPluginKey,
                ...createMemeSuggestion(),
            }),
        ]
    },
})

export default MemeSuggestionExtension
